import clientConfigApi from '../config/config'


export const getClearCredentials = async () => {
    const config = {
        headers: { Authorization: `Bearer ${localStorage.getItem('GuestJourneySessionToken')}` }
    };

    try {
        let data = await clientConfigApi.get(`mobileCheckIn/guestIdentityVerification`, config)
        return data
    } catch (e) {
        return e
    }
}


export const validateClearVerification = async (authCode , confirmationNumber) => {

    const config = {
        header: { 
            sessionToken: `${localStorage.getItem('GuestJourneySessionToken')}`,
         },
        payload: {
            confirmationNumber: `${confirmationNumber}`
        }
    };

    const headers = {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${authCode}`   
        }
    }

    try {
        let data = await clientConfigApi.post(`mobileCheckIn/guestIdentityVerification`, config, headers )

        return data
    } catch (error) {
        return error
    }

}